export default {
  "content": "<path d=\"M18.479 1H4.992a.524.524 0 00-.521.521v13.487c0 .297.248.52.521.52H18.48a.524.524 0 00.521-.52V1.52A.51.51 0 0018.479 1zm-.52 13.488H5.512V2.04h12.422v12.447h.025zm-2.43 3.991a.524.524 0 01-.521.521H1.52A.524.524 0 011 18.479V4.992c0-.297.248-.52.521-.52s.521.247.521.52V17.96H15.01c.296 0 .52.223.52.52h0zM8.289 8.265c0-.298.249-.522.522-.522h2.38v-2.38c0-.297.248-.521.521-.521.298 0 .521.248.521.521v2.38h2.38c.298 0 .522.248.522.522a.524.524 0 01-.521.52h-2.38v2.381a.524.524 0 01-.522.521.524.524 0 01-.52-.52V8.785H8.81a.524.524 0 01-.521-.521z\" fill=\"#0065DC\" stroke=\"#0065DC\" stroke-width=\".5\"/>",
  "attrs": {
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};